var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.curPage=='NoteList')?_c('NoteList',{on:{"changePage":_vm.changePage}}):_c('NoteDetail',{attrs:{"detail":_vm.detail},on:{"changePage":_vm.changePage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }